











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.User.ResetPasswordCommand')
    
    export class ResetPasswordCommand {
        constructor( eMail: string ) {
            
                this.eMail = eMail;
            
        }

        
            public eMail: string;
        
    }

    export interface IResetPasswordCommand {
        
            eMail: string;
        
    }

    export async function resetPassword( command: ResetPasswordCommand ): Promise<CommandResult<void>>
    export async function resetPassword( { eMail }: IResetPasswordCommand ): Promise<CommandResult<void>>
    export async function resetPassword( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof ResetPasswordCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new ResetPasswordCommand( model['eMail'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace ResetPasswordCommand.ExtraneousTypes {
        

        
    }

